(function() {
    'use strict';

    var observer = null;

    function checkAddToCartVisibility() {
        var addToCartButton = document.querySelector('.pdp-addtocart');

        // Clean up existing observer
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        if (!addToCartButton) {
            return;
        }

        // Create intersection observer to watch the add to cart button
        observer = new IntersectionObserver(
            function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        // Button is visible, remove class
                        document.body.classList.remove('off-atc');
                    } else {
                        // Button is NOT visible, add class
                        document.body.classList.add('off-atc');
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }
        );

        observer.observe(addToCartButton);
    }

    /**
     * Resolve the product form: prefer explicit element, then .fs-pdp-wrap, then any bundle form.
     */
    function getProductForm(formOrContext) {
        if (formOrContext && formOrContext.matches && formOrContext.matches('form.fs-product-form')) {
            return formOrContext;
        }
        if (formOrContext && formOrContext.closest) {
            var fromClosest = formOrContext.closest('form.fs-product-form');
            if (fromClosest) return fromClosest;
        }
        var scoped = document.querySelector('.fs-pdp-wrap form.fs-product-form');
        return scoped || document.querySelector('form.fs-product-form');
    }

    function refreshPackPricing(form) {
        form = getProductForm(form);
        if (!form) return;
        syncActivePackSizeFromQuantity(form);
        syncQuoteviewPackLabel(form);
        updateAddToCartPriceWithQuantity(form);
        updateSaveTextWithActivePack(form);
        updateFreeShippingLabels(form);
    }

    /**
     * Toggle FREE SHIPPING under pack options when line total meets threshold (US, cents).
     */
    function updateFreeShippingLabels(form) {
        form = getProductForm(form);
        if (!form) return;

        var groups = form.querySelector('.jsp-groups[data-fs-free-ship-threshold]');
        if (!groups) return;

        var threshold = parseInt(groups.getAttribute('data-fs-free-ship-threshold'), 10);
        if (isNaN(threshold) || threshold <= 0) return;

        var packItems = form.querySelectorAll('.jspg-qty');
        for (var i = 0; i < packItems.length; i++) {
            var el = packItems[i];
            var label = el.querySelector('.jsfs');
            if (!label) continue;

            var unitCents = parseInt(el.getAttribute('data-jsp-price'), 10) || 0;
            var count = parseInt(el.getAttribute('data-jsp-count'), 10) || 1;
            var lineTotal = unitCents * count;

            if (lineTotal >= threshold) {
                label.removeAttribute('hidden');
            } else {
                label.setAttribute('hidden', '');
            }
        }
    }

    /**
     * Keep `.quoteview-wrap .zop-title span` in sync with the active bundle row (`.jspg-qty.active`).
     */
    function syncQuoteviewPackLabel(form) {
        form = getProductForm(form);
        if (!form) return;

        var wrap = form.querySelector('.quoteview-wrap');
        if (!wrap) return;
        if (wrap.getAttribute('data-fs-pack-size-fixed') === 'true') return;

        var activePack = form.querySelector('.jspg-qty.active');
        if (!activePack) return;

        var count = activePack.getAttribute('data-jsp-count');
        if (count === null || String(count).length === 0) return;

        var labelBase = wrap.getAttribute('data-fs-pack-label');
        if (!labelBase || !String(labelBase).trim()) {
            labelBase = 'Pack';
        } else {
            labelBase = String(labelBase).trim();
        }

        var titleEl = wrap.querySelector('.zop-title');
        if (!titleEl) return;

        var span = titleEl.querySelector('span');
        if (!span) {
            span = document.createElement('span');
            titleEl.appendChild(span);
        }
        span.textContent = ' ' + String(count).trim() + '  ' + labelBase;
    }

    /**
     * When quantity-input changes: set active on the .jspg-qty whose data-jsp-count is the
     * largest value <= quantity (e.g. qty 5 → active data-jsp-count=4, not 2 or 1).
     */
    function syncActivePackSizeFromQuantity(form) {
        form = getProductForm(form);
        if (!form) return;

        var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input') || form.querySelector('.quantity-input');
        if (!qtyInput) return;

        var quantity = parseInt(qtyInput.value, 10) || 1;
        var allPackOptions = form.querySelectorAll('.jspg-qty');
        if (!allPackOptions.length) return;

        var best = null;
        var bestCount = 0;
        for (var i = 0; i < allPackOptions.length; i++) {
            var count = parseInt(allPackOptions[i].getAttribute('data-jsp-count'), 10);
            if (!isNaN(count) && count <= quantity && count >= bestCount) {
                bestCount = count;
                best = allPackOptions[i];
            }
        }
        if (!best) return;

        var parent = best.parentElement;
        if (parent) {
            var siblings = parent.querySelectorAll('.jspg-qty');
            for (var j = 0; j < siblings.length; j++) {
                siblings[j].classList.remove('active');
            }
        }
        best.classList.add('active');
    }

    function getAtcMoneyWithCurrencyFormat(form) {
        var g = typeof window !== 'undefined' && window.__FS_PDP_MONEY_WITH_CURRENCY_FORMAT__;
        if (g && String(g).length) {
            return g;
        }
        if (!form || typeof form.querySelector !== 'function') return null;
        var el = form.querySelector('[data-atc-money-with-currency-format]');
        if (!el || !el.getAttribute) return null;
        var fmt = el.getAttribute('data-atc-money-with-currency-format');
        return fmt && String(fmt).length ? fmt : null;
    }

    function getFsPdpCurrencyIso(form) {
        var raw = typeof window !== 'undefined' ? window.__FS_PDP_CURRENCY_ISO__ : null;
        if ((!raw || String(raw).length === 0) && form && typeof form.querySelector === 'function') {
            var el = form.querySelector('[data-fs-pdp-currency-iso]');
            if (el && el.getAttribute) raw = el.getAttribute('data-fs-pdp-currency-iso');
        }
        if (!raw || typeof raw !== 'string') return null;
        var iso = String(raw).trim().toUpperCase();
        if (!/^[A-Z]{3}$/.test(iso)) return null;
        return iso;
    }

    function getFsPdpLocale() {
        var loc = typeof window !== 'undefined' && window.__FS_PDP_LOCALE__;
        if (loc && typeof loc === 'string' && String(loc).trim().length) {
            return String(loc).trim();
        }
        return undefined;
    }

    function getFsPdpCurrencySymbol(form) {
        var sym = typeof window !== 'undefined' ? window.__FS_PDP_CURRENCY_SYMBOL__ : null;
        if ((!sym || String(sym).length === 0) && form && typeof form.querySelector === 'function') {
            var el = form.querySelector('[data-fs-pdp-currency-symbol]');
            if (el && el.getAttribute) sym = el.getAttribute('data-fs-pdp-currency-symbol');
        }
        return sym && typeof sym === 'string' ? sym : '';
    }

    /**
     * Money for ATC: Intl when possible; Shopify.formatMoney; then symbol + amount + ISO from Liquid.
     * @param {boolean} [isCompare] — when true (strikethrough compare), use plain shop money only (no currency / ISO).
     */
    function formatMoneyCents(cents, moneyFormat, form, isCompare) {
        var c = parseInt(cents, 10);
        if (isNaN(c) || c < 0) c = 0;

        if (isCompare) {
            if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
                return window.Shopify.formatMoney(c);
            }
            var symC = getFsPdpCurrencySymbol(form);
            var amtC = (c / 100).toFixed(2);
            return symC ? symC + amtC : '$' + amtC;
        }

        var iso = getFsPdpCurrencyIso(form);
        var sym = getFsPdpCurrencySymbol(form);
        var amt = (c / 100).toFixed(2);

        var out = '';

        if (iso && typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
            try {
                out = new Intl.NumberFormat(getFsPdpLocale(), {
                    style: 'currency',
                    currency: iso
                }).format(c / 100);
            } catch (eIntl) { out = ''; }
        }

        if (!out) {
            var fmt = moneyFormat;
            if (!fmt && typeof window !== 'undefined' && window.__FS_PDP_MONEY_WITH_CURRENCY_FORMAT__) {
                fmt = window.__FS_PDP_MONEY_WITH_CURRENCY_FORMAT__;
            }
            if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
                if (fmt && String(fmt).length) {
                    out = window.Shopify.formatMoney(c, fmt);
                } else {
                    out = window.Shopify.formatMoney(c);
                }
            }
        }

        if (!out) {
            if (sym && iso) out = sym + amt + ' ' + iso;
            else if (iso) out = amt + ' ' + iso;
            else if (sym) out = sym + amt;
            else out = '$' + amt;
        }

        // Many locales hide the ISO code (e.g. "$12.34"); storefront compare uses money_with_currency — always suffix ISO when we know it.
        if (iso && out && String(out).toUpperCase().indexOf(iso) === -1) {
            out = String(out).trim() + ' ' + iso;
        }
        return out;
    }

    function getSelectedVariantPriceCents(form) {
        var selectBox = form.querySelector('.pr-variants');
        if (!selectBox || !selectBox.options || !selectBox.options.length) return 0;
        var selectedOption = selectBox.options[selectBox.selectedIndex];
        if (!selectedOption) return 0;
        var price = parseInt(selectedOption.getAttribute('data-price'), 10);
        return isNaN(price) ? 0 : price;
    }

    function getSelectedVariantCompareAtCents(form) {
        var selectBox = form.querySelector('.pr-variants');
        if (!selectBox || !selectBox.options || !selectBox.options.length) return NaN;
        var selectedOption = selectBox.options[selectBox.selectedIndex];
        if (!selectedOption) return NaN;
        var cmp = parseInt(selectedOption.getAttribute('data-compare-at-price'), 10);
        return isNaN(cmp) ? NaN : cmp;
    }

    function discountedUnitPriceCents(baseUnitCents, keepPct) {
        if (isNaN(baseUnitCents) || baseUnitCents <= 0) return 0;
        if (isNaN(keepPct) || keepPct <= 0) return 0;
        if (keepPct >= 100) return baseUnitCents;
        // Integer ceil division: ceil(baseUnitCents * keepPct / 100)
        return Math.floor((baseUnitCents * keepPct + 99) / 100);
    }

    /**
     * Update add-to-cart button price (all .addtocart .pr) based on quantity and active pack size.
     * Bundle (.jspg-qty): discounted line total + optional manual compare (full variant × qty) in <s>.
     * Non-bundle: variant line total + Shopify compare-at from option data-compare-at-price when present.
     */
    function updateAddToCartPriceWithQuantity(form) {
        form = getProductForm(form);
        if (!form) return;

        var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input') || form.querySelector('.quantity-input');
        if (!qtyInput) return;

        var qty = parseInt(qtyInput.value, 10) || 1;
        var variantUnitPriceCents = getSelectedVariantPriceCents(form);
        var unitPriceCents = variantUnitPriceCents;
        var moneyFmt = getAtcMoneyWithCurrencyFormat(form);

        var activeQty = form.querySelector('.jspg-qty.active');
        var hasBundleCompare = false;
        if (activeQty) {
            var discountPct = parseInt(activeQty.getAttribute('data-jsp-discount'), 10);
            if (!isNaN(discountPct) && discountPct > 0 && discountPct <= 100 && variantUnitPriceCents > 0) {
                // Match checkout behavior for bundle pricing:
                // compute per-unit discounted price, round to cent, then multiply by quantity.
                unitPriceCents = discountedUnitPriceCents(variantUnitPriceCents, discountPct);
                hasBundleCompare = discountPct < 100;
            } else {
                unitPriceCents = parseInt(activeQty.getAttribute('data-jsp-price'), 10);
            }
        }

        if (isNaN(unitPriceCents) || unitPriceCents <= 0) return;

        var totalCents = unitPriceCents * qty;
        var displayPrice = formatMoneyCents(totalCents, moneyFmt, form);
        var priceHtml = displayPrice;

        if (activeQty && hasBundleCompare && variantUnitPriceCents > 0) {
            var bundleCompareTotalCents = variantUnitPriceCents * qty;
            if (bundleCompareTotalCents > totalCents) {
                priceHtml = displayPrice + ' <s>' + formatMoneyCents(bundleCompareTotalCents, moneyFmt, form, true) + '</s>';
            }
        } else if (!activeQty) {
            var compareUnitCents = getSelectedVariantCompareAtCents(form);
            if (!isNaN(compareUnitCents) && compareUnitCents > variantUnitPriceCents) {
                var variantCompareTotalCents = compareUnitCents * qty;
                if (variantCompareTotalCents > totalCents) {
                    priceHtml = displayPrice + ' <s>' + formatMoneyCents(variantCompareTotalCents, moneyFmt, form, true) + '</s>';
                }
            }
        }

        var mainPr = form.querySelector('.addtocart .pr');
        if (mainPr) mainPr.innerHTML = '| ' + priceHtml;

        var formId = form.getAttribute('id');
        var stickyRoot = formId
            ? document.querySelector('.product-form-sticky-button[data-product-form-id="' + formId + '"]')
            : null;
        var stickyPr = stickyRoot ? stickyRoot.querySelector('.pr') : document.querySelector('.product-form-sticky-button__btn .pr');
        if (stickyPr) stickyPr.innerHTML = '| ' + priceHtml;

        var afterpayCents = Math.round(totalCents / 4);
        var afterpayFormatted = formatMoneyCents(afterpayCents, moneyFmt, form);
        var afterpayEls = form.querySelectorAll('.afterpay-price');
        for (var a = 0; a < afterpayEls.length; a++) {
            afterpayEls[a].textContent = afterpayFormatted;
        }
    }

    /**
     * Update `.z-savetext` based on the active bundle pack size.
     * Note: HTML stores `data-jsp-discount` as `hundred_minus_discount` (= remaining % after discount),
     * so savings % = 100 - hundred_minus_discount.
     */
    function updateSaveTextWithActivePack(form) {
        form = getProductForm(form);
        if (!form) return;

        var saveEl = form.querySelector('.z-savetext');
        if (!saveEl) return;

        var template = saveEl.getAttribute('data-save-template');
        if (!template) return;

        var activeQty = form.querySelector('.jspg-qty.active');
        if (!activeQty) return;

        var hundredMinusDiscountPct = parseInt(activeQty.getAttribute('data-jsp-discount'), 10);
        if (isNaN(hundredMinusDiscountPct)) return;

        var savePct = 100 - hundredMinusDiscountPct;
        if (savePct <= 0) {
            saveEl.style.display = 'none';
            return;
        }

        saveEl.style.display = '';
        saveEl.innerHTML = template.replace('//save//', String(savePct));
    }

    function init() {
        // Initial check
        checkAddToCartVisibility();
        var form = getProductForm();
        if (form && form.querySelector('.jspg-qty')) {
            refreshPackPricing(form);
        } else if (form) {
            updateSaveTextWithActivePack(form);
        }

        // Re-apply after other theme scripts (swatch sync, variant HTML, morph) overwrite `.pr`.
        function reapplyAtcMoney() {
            var f = getProductForm();
            if (!f) return;
            if (f.querySelector('.jspg-qty')) {
                refreshPackPricing(f);
            } else if (typeof updateAddToCartPriceWithQuantity === 'function') {
                updateAddToCartPriceWithQuantity(f);
            }
        }
        setTimeout(reapplyAtcMoney, 250);
        setTimeout(reapplyAtcMoney, 650);
        setTimeout(reapplyAtcMoney, 1400);

        document.addEventListener('variant:update', function() {
            setTimeout(reapplyAtcMoney, 0);
            setTimeout(reapplyAtcMoney, 120);
            setTimeout(reapplyAtcMoney, 320);
        });

        // Watch for form container changes (AJAX loaded content)
        var formContainer = document.querySelector('.sp-product-form-container');
        if (formContainer) {
            var formMutationObserver = new MutationObserver(function() {
                // Re-check when form content changes
                setTimeout(function() {
                    checkAddToCartVisibility();
                }, 200);
            });

            formMutationObserver.observe(formContainer, {
                childList: true,
                subtree: true
            });
        }

        // Single delegated click handler: bundle (theme), sticky button, quantity +/-
        document.body.addEventListener('click', function(e) {
            var target = e.target;

            // 1. .qw-click: trigger quote link
            if (target.closest && target.closest('.qw-click')) {
                var quoteLink = document.querySelector('.pdp-fs-quote-link');
                if (quoteLink) quoteLink.click();
                return;
            }

            // 2. Sticky button: submit form
            var stickyButton = target.closest && target.closest('.product-form-sticky-button__btn');
            if (stickyButton) {
                e.preventDefault();
                if (!stickyButton.disabled) {
                    var stickyWrap = stickyButton.closest('.product-form-sticky-button');
                    var fid = stickyWrap && stickyWrap.getAttribute('data-product-form-id');
                    var stickyForm = fid ? document.getElementById(fid) : getProductForm();
                    if (stickyForm) {
                        stickyForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                }
                return;
            }

            // 3. Quantity plus/minus for .sbp-qty
            var quantityButton = target.closest && target.closest('.sbp-qty .quantity-plus, .sbp-qty .quantity-minus');
            if (quantityButton) {
                e.preventDefault();
                var sbpQty = quantityButton.closest('.sbp-qty');
                var quantityInput = sbpQty && sbpQty.querySelector('.quantity-input');
                if (quantityInput) {
                    var currentValue = parseInt(quantityInput.value, 10) || 1;
                    var minValue = parseInt(quantityInput.getAttribute('min'), 10) || 1;
                    var maxValue = parseInt(quantityInput.getAttribute('max'), 10) || 999;
                    var newValue = quantityButton.classList.contains('quantity-plus')
                        ? Math.min(currentValue + 1, maxValue)
                        : Math.max(currentValue - 1, minValue);
                    if (newValue !== currentValue) {
                        quantityInput.value = newValue;
                        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                return;
            }

            // 4. Product option (.jspg-product): fetch and replace form
            if (target.closest && target.closest('.jspg-product')) {
                e.preventDefault();
                var clicked = target.closest('.jsp-gitem');
                var currentFormContainer = clicked.closest('.sp-product-form-container');
                var keptValue = null;
                if (currentFormContainer) {
                    var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
                    if (firstOSelected) {
                        keptValue = firstOSelected.getAttribute('data-oselected-value');
                    }
                }
                var href = clicked.getAttribute('href');
                if (href) {
                    fetch(href)
                        .then(function(response) { return response.text(); })
                        .then(function(html) {
                            var tempDiv = document.createElement('div');
                            tempDiv.innerHTML = html;
                            var newFormContainer = tempDiv.querySelector('.sp-product-form-container');
                            if (newFormContainer && currentFormContainer) {
                                currentFormContainer.innerHTML = newFormContainer.innerHTML;
                                if (keptValue !== null) {
                                    var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                                    if (firstOSelectedNew) {
                                        var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                                        if (matchingChild) {
                                            matchingChild.click();
                                        }
                                    }
                                }
                            }
                            var a = document.createElement('a');
                            a.href = href;
                            window.history.replaceState({}, '', a.pathname);
                        })
                        .catch(function(err) { console.error('Error fetching product form:', err); });
                }
                return;
            }

            // 5. Quantity / pack-size option (.jspg-qty)
            if (target.closest && target.closest('.jspg-qty')) {
                e.preventDefault();
                var clickedQty = target.closest('.jspg-qty');
                var jspCount = clickedQty.getAttribute('data-jsp-count');
                var qtyParent = clickedQty.parentElement;
                if (qtyParent) {
                    var qtySiblings = qtyParent.querySelectorAll('.jspg-qty');
                    qtySiblings.forEach(function(sib) { sib.classList.remove('active'); });
                }
                clickedQty.classList.add('active');
                var form = clickedQty.closest('form');
                if (form) {
                    var qtyInput = form.querySelector('.qty-ad-wrap .quantity-input');
                    if (qtyInput && jspCount !== null) {
                        qtyInput.value = jspCount;
                    }
                }
                refreshPackPricing(form);
                setTimeout(function() { checkAddToCartVisibility(); }, 300);
                return;
            }

            // 6. Other bundle option (.jsp-gitem): re-check add-to-cart visibility
            if (target.closest && target.closest('.jsp-gitem')) {
                setTimeout(function() {
                    checkAddToCartVisibility();
                }, 300);
            }
        });

        // Handle manual quantity input changes (min/max validation + update button price)
        document.body.addEventListener('change', function(e) {
            var target = e.target;
            if (!target || !target.classList.contains('quantity-input')) {
                return;
            }
            var form = target.closest('form.fs-product-form');
            if (!form) {
                return;
            }
            var minValue = parseInt(target.getAttribute('min'), 10) || 1;
            var maxValue = parseInt(target.getAttribute('max'), 10) || 999;
            var inputValue = parseInt(target.value, 10);
            if (isNaN(inputValue) || inputValue < minValue) {
                target.value = minValue;
            } else if (inputValue > maxValue) {
                target.value = maxValue;
            }
            if (form.querySelector('.jspg-qty')) {
                refreshPackPricing(form);
            }
        });

        // When pr-variants (variant select) changes: recompute .jspg-qty data-jsp-price from selected option data-price and each item's data-jsp-discount
        document.body.addEventListener('change', function(e) {
            if (!e.target || !e.target.classList || !e.target.classList.contains('pr-variants')) return;
            var selectBox = e.target;
            var form = selectBox.closest('form');
            if (!form) return;
            var selectedOption = selectBox.options[selectBox.selectedIndex];
            if (!selectedOption) return;
            var variantPriceCents = parseInt(selectedOption.getAttribute('data-price'), 10);
            if (isNaN(variantPriceCents) || variantPriceCents <= 0) return;
            var packItems = form.querySelectorAll('.jspg-qty');
            for (var i = 0; i < packItems.length; i++) {
                var el = packItems[i];
                var discountPct = parseInt(el.getAttribute('data-jsp-discount'), 10);
                if (isNaN(discountPct) || discountPct <= 0) discountPct = 100;
                var newPrice = discountedUnitPriceCents(variantPriceCents, discountPct);
                el.setAttribute('data-jsp-price', String(newPrice));
            }
            if (packItems.length) {
                refreshPackPricing(form);
                // Some theme handlers write .pr later in the same event cycle.
                setTimeout(function() { refreshPackPricing(form); }, 0);
                setTimeout(function() { refreshPackPricing(form); }, 180);
            }
        });
    }

    window.FSPDP = window.FSPDP || {};
    window.FSPDP.getProductForm = getProductForm;
    window.FSPDP.refreshPackPricing = refreshPackPricing;
    window.FSPDP.updateAddToCartPriceWithQuantity = updateAddToCartPriceWithQuantity;

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Also check after a delay to ensure button is loaded
    setTimeout(checkAddToCartVisibility, 500);
})();
